import { useAtom } from 'jotai';
import { useMemo } from 'react';

import type { PERMISSIONS_LOGIC } from '@/constants/common';
import { selectedOrganizationAtom } from '@/pages/Organizations';
import { checkPermissions } from '@/services/permissions';
import userAtom from '@/store/user.store';

export const usePermissionsCheck = (
  permissions: string | string[],
  logic?: PERMISSIONS_LOGIC
) => {
  const [user] = useAtom(userAtom);
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);

  const hasPermissions = useMemo(() => {
    return checkPermissions(permissions, user, selectedOrganization, logic);
  }, [permissions, user, selectedOrganization, logic]);

  return hasPermissions;
};

export default usePermissionsCheck;
